import { Component } from '@angular/core';

@Component({
  selector: 'app-ai-config',
  templateUrl: './ai-config.component.html',
  styleUrls: ['./ai-config.component.css'],
  standalone: false,
})
export class AiConfigComponent {
  constructor() {}
}
